import * as React from 'react';

function ModalDadosLogin({ handleModal }) {
    return (
        <div id="modalDadosLogin" className="bundleTela bundleBackgroundPopup" style={{ "marginTop": "50px" }}>
            <div className="bundleBox2">
                <label className="bundleTitulo bundleCentro">
                    Seus dados não foram reconhecidos?
                </label>
                <span id="linkCloseModal" className="close" onClick={() => handleModal(false)}>&times;</span>

                <label className="bundleLabelPopup1">
                    <p>Entre em contato com o seu corretor ou com nossos canais de atendimento, <br />
                    que você pode encontrar no e-mail que te trouxe até aqui.</p>
                </label>
            </div>
        </div >
    );
}

export default ModalDadosLogin;